import cookiePolicy from "../../data/cookiePolicy";
import LegalAccordion from "../../components/LegalAccordion";
import "./CookiePolicyPage.css";


const CookiePolicyPage = () => {

    return (

        <section className="cookie-page">


            <div className="cookie-hero">


                <span>
                    Legal
                </span>


                <h1>
                    Cookie Policy
                </h1>


                <p>
                    Learn how Magyne uses cookies and similar
                    technologies to provide secure and reliable
                    digital experiences.
                </p>


                <div className="effective-date">

                    Effective Date: July 29, 2026

                </div>


            </div>



            <div className="cookie-container">


                {
                    cookiePolicy.map(section => (

                        <LegalAccordion
                            key={section.id}
                            section={section}
                        />

                    ))
                }


            </div>


        </section>

    );

};


export default CookiePolicyPage;